<template>
  <b-modal
    :id="modalId"
    ref="modalSuccessDelete"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    body-class="p-0"
    dialog-class="custom-width-modal"
  >
    <div class="komed-modal-container">
      <!-- Icon -->
      <div class="komed-modal-icon-wrapper">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/success.svg"
          alt="Success"
          width="100"
          height="100"
        >
      </div>

      <!-- Text -->
      <h4 class="komed-modal-title">
        Konten Berhasil Dihapus
      </h4>
      <p class="komed-modal-subtitle">
        Konten yang kamu pilih telah berhasil dihapus dan tidak dapat dipulihkan.
      </p>

      <!-- Actions -->
      <b-button
        block
        class="komed-btn-oke"
        @click="handleClose"
      >
        Oke
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$bvModal.hide(this.modalId)
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
::v-deep .custom-width-modal .modal-dialog {
  max-width: 440px;
  border-radius: 24px;
}
::v-deep .custom-width-modal .modal-content {
  border-radius: 24px;
  border: none;
}
.komed-modal-container {
  background: white;
  border-radius: 24px;
  padding: 32px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.komed-modal-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}
.komed-modal-title {
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  color: #1f1f1f;
  margin-bottom: 8px;
  margin-top: 0;
}
.komed-modal-subtitle {
  text-align: center;
  color: #8c8c8c;
  font-size: 14px;
  margin-bottom: 32px;
  margin-top: 0;
  line-height: 1.5;
}
.komed-btn-oke {
  width: 100%;
  height: 48px;
  border-radius: 16px;
  font-weight: 500;
  color: white !important;
  background: #ff6a13 !important;
  border: none !important;
  margin: 0;
}
.komed-btn-oke:hover {
  background: #ff7d32 !important;
}
</style>
